import type { FunctionComponent } from 'react';

import { config } from '../../../../config/config';
import { Button, ButtonSize } from '../../../shared/components/button/button';
import { FormattedMessage } from '../../../shared/components/formatted-message/formatted-message';
import { ModalContainer } from '../../../shared/components/modal-container/modal-container';
import { createStyleHelper } from '../../../shared/utils/class-names';
import type { BlockType } from '../../hooks/use-compliance-prompt';

import styles from './compliance-prompt.module.scss';

const style = createStyleHelper(styles, 'compliance-prompt');

export interface ICompliancePromptProps {
    blockType: BlockType;
    errors?: string[];
}

export const CompliancePrompt: FunctionComponent<ICompliancePromptProps> = ({
    blockType,
    errors,
}) => {
    const firstError = errors?.[0];

    return (
        <ModalContainer>
            <section className={style()}>
                {/*<Icon*/}
                {/*    className={style('icon')}*/}
                {/*    name={'exclamation-triangle'}*/}
                {/*    size={IconSize.LARGE}*/}
                {/*/>*/}

                <h1 className={style('title')}>
                    <FormattedMessage
                        id={`compliance-prompt.block.${blockType}.title`}
                        defaultMessage={'Oops!'}
                    />
                </h1>
                <p className={style('description')}>
                    {firstError ? (
                        <FormattedMessage
                            id={`compliance-prompt.block.${blockType}.${firstError}.message`}
                            defaultMessage={
                                'We could not verify your location. Please check that XPoint is {link} and running on your device.<br></br><br></br>'
                            }
                            values={{
                                // errorCode: firstError,
                                // trigger
                                link: (
                                    <a
                                        className={style('link')}
                                        href={config.GEOLOCATION.INSTALL_LINK}
                                    >
                                        <FormattedMessage
                                            id="compliance-prompt.geolocation.install"
                                            defaultMessage="installed"
                                        />
                                    </a>
                                ),
                            }}
                        />
                    ) : (
                        <>
                            <FormattedMessage
                                id={`compliance-prompt.block.${blockType}.message`}
                                defaultMessage={
                                    'Sorry! You can’t do that right now.<br></br>Please contact our support team at '
                                }
                            />
                            <a
                                href={'mailto:support@crabsports.com'}
                                className={style('description')}
                                rel="noreferrer"
                            >
                                <FormattedMessage
                                    id="compliance-prompt.email"
                                    defaultMessage="support@crabsports.com"
                                />
                            </a>
                            <FormattedMessage
                                id="compliance-prompt.for-help"
                                defaultMessage=" for help"
                            />
                        </>
                    )}
                </p>
                <Button className={style('action')} size={ButtonSize.SMALL} href="/account">
                    <FormattedMessage
                        id="compliance-prompt.block.back-to-account"
                        defaultMessage={'Go to My Account'}
                    />
                </Button>
            </section>
        </ModalContainer>
    );
};
